export default __webpack_public_path__ + "static/media/DESTINATION CANADA-HUB-1.56cdd546.jpg";